export function getAllAgreements(axiosPrivate){
  return axiosPrivate.get('/trade-data-agreement/list-agreements')
}

export function getOptionAgreements(axiosPrivate){
  return axiosPrivate.get('/trade-data-agreement/options')
}

export function getAgreementById(axiosPrivate, params){
  const id = params.idAgreement
  return axiosPrivate.get(`/trade-data-agreement/${id}`)
}

export function submitChapterToReview(axiosPrivate, body){
  return axiosPrivate.post('/trade-data-agreement/chapter', body)
}

export function getChapterById(axiosPrivate, params){
  const id = params.idChapter
  return axiosPrivate.get(`/trade-data-agreement/chapter/${id}`)
}

export function submitReorderChapter(axiosPrivate, body){
  return axiosPrivate.post('/trade-data-agreement/chapter/edit-order', body)
}